import React from 'react';
import styles from './styles/ErrorOverlay.module.css';
import { useCanvas } from '../../../context/CanvasContext';
import { useEditorUI } from '../../../context/EditorUIContext';
import { TUTORIAL_TARGETS, tutorialAttr } from '../../../tutorials';

/**
 * Lists the reasons the scenario cannot be published, and jumps to whatever is
 * at fault when clicked.
 *
 * The errors come from either the client's `checkValidity` pre-flight or the
 * server's 422 — both produce the same `{ node?, edge?, reason }` shape, so this
 * renders them identically without knowing which it got.
 */
function ErrorOverlay() {
    const { graphErrors } = useCanvas();
    const { selectItem } = useEditorUI();

    if (!graphErrors || graphErrors.length === 0) return null;

    return (
        <div className={styles.overlay}>
            {graphErrors.map((error, index) => {
                const target = error.node || error.edge;
                const label = target?.data?.title || 'Untitled';

                return (
                    <div
                        key={`${error.reason}-${target?.id ?? index}`}
                        className={styles.item}
                        onClick={() => {
                            if (error.node) selectItem('situation', error.node.id);
                            else if (error.edge) selectItem('choice', error.edge.id);
                        }}
                        {...tutorialAttr(TUTORIAL_TARGETS.ERROR_ITEM, target?.id)}
                    >
                        {target ? <span className={styles.label}>{label}</span> : null}
                        <span className={styles.reason}> - {error.reason}</span>
                    </div>
                );
            })}
        </div>
    );
}

export default ErrorOverlay;
